import React from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours, sizes } from '@qflow/theme'
import { SideBar, icons } from 'portal/lib/primitives'
import { useResponsive } from 'portal/lib/hooks'
import { useUserAccountRole } from 'portal/lib/hooks/useUserAccountRole'

export function AccountSettingsSidebarButton({ accountId, accountsTable }) {
  const { isMobile } = useResponsive()
  const { isAdmin } = useUserAccountRole(accountId)
  const isCollapsed = useSelector(state => state.ui.data.sidebarCollapsed)

  if (!isAdmin || isMobile) {
    return null
  }

  return isCollapsed ? (
    <Tooltip title="Account Settings" placement="right">
      <StyledNavLink
        id="AccountSettingsPageSideBarButton"
        disabled={accountsTable === ''}
        to={accountsTable}
      >
        <icons.AccountSettingsIcon size={sizes.MEDIUM} colour="currentColor" />
      </StyledNavLink>
    </Tooltip>
  ) : (
    <SideBar.NavButton
      disabled={accountsTable === ''}
      id="AccountSettingsPage"
      to={accountsTable}
      Icon={icons.AccountSettingsIcon}
      noWrapper={true}
      minimalMargin={true}
    >
      Account Settings
    </SideBar.NavButton>
  )
}

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 6px;
  padding: 8px 8px 8px 10px;
  color: #ffffff;
  opacity: 0.8;

  &:hover:not(.active) {
    opacity: 1;
    color: #ffffff;
  }

  &.active {
    color: ${colours.TEAL};
    background-color: rgba(255, 255, 255, 0.1) !important;
    opacity: 1;
  }
`
